import { render } from "./frameComp.vue?vue&type=template&id=9296437e"
import script from "./frameComp.vue?vue&type=script&lang=js"
export * from "./frameComp.vue?vue&type=script&lang=js"

import "./frameComp.vue?vue&type=style&index=0&id=9296437e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__